// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"495":"7a398a42","591":"acf2828d"}[chunkId] + ".chunk.js";
};